import { Clock } from '@ethsign/icons';
import { Input, Popover, ScrollArea } from "./..";
import dayjs from 'dayjs';
import React, { useEffect, useRef } from 'react';
import { cn } from "../lib/utils";
var generateOptions = function generateOptions(start, end) {
  var options = [];
  for (var i = start; i <= end; i++) {
    options.push(i.toString().padStart(2, '0'));
  }
  return options;
};
var TimeSelect = function TimeSelect(_ref) {
  var options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange;
  var ref = useRef(null);
  //滚动到对应的option
  useEffect(function () {
    if (!value) return;
    if (ref) {
      var _ref$current;
      var y = 24 * Number(value);
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(ScrollArea, {
    className: "h-[200px] w-[56px] flex-1",
    ref: ref
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        onChange(option);
      },
      key: option,
      className: cn('text-center cursor-pointer hover:bg-accent text-foreground rounded-sm', value === option ? 'text-primary-500 bg-primary-100' : '')
    }, option);
  }));
};
export var TimePicker = function TimePicker(_ref2) {
  var value = _ref2.value,
    _onChange = _ref2.onChange,
    className = _ref2.className,
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? 'HH:mm:ss' : _ref2$format;
  var formatArr = format === null || format === void 0 ? void 0 : format.split(':');
  return /*#__PURE__*/React.createElement("div", {
    className: cn('min-w-[100px] inline-flex', className)
  }, /*#__PURE__*/React.createElement(Popover, {
    trigger: /*#__PURE__*/React.createElement(Input, {
      suffix: /*#__PURE__*/React.createElement(Clock, {
        color: '#667085'
      }),
      className: 'cursor-pointer',
      readOnly: true,
      value: dayjs(value).format(format)
    }),
    contentProps: {
      side: 'bottom',
      align: 'start',
      className: 'w-auto py-2 px-1'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-4 items-center"
  }, (formatArr === null || formatArr === void 0 ? void 0 : formatArr.includes('HH')) && /*#__PURE__*/React.createElement(TimeSelect, {
    options: generateOptions(0, 23),
    value: dayjs(value).hour().toString().padStart(2, '0'),
    onChange: function onChange(v) {
      _onChange(dayjs(value).hour(parseInt(v)).toDate());
    }
  }), (formatArr === null || formatArr === void 0 ? void 0 : formatArr.includes('mm')) && /*#__PURE__*/React.createElement(TimeSelect, {
    options: generateOptions(0, 59),
    value: dayjs(value).minute().toString().padStart(2, '0'),
    onChange: function onChange(v) {
      _onChange(dayjs(value).minute(parseInt(v)).toDate());
    }
  }), (formatArr === null || formatArr === void 0 ? void 0 : formatArr.includes('ss')) && /*#__PURE__*/React.createElement(TimeSelect, {
    options: generateOptions(0, 59),
    value: dayjs(value).second().toString().padStart(2, '0'),
    onChange: function onChange(v) {
      _onChange(dayjs(value).second(parseInt(v)).toDate());
    }
  }))));
};